import { FooterVariant, OverlayPages, PromptVariant, SvgIcon } from "@skylead/component-library"
// eslint-disable-next-line import/no-cycle
import React from "react"
import { Link } from "react-router-dom"

import EmailAccountsStatusOverview from "../components/atoms/EmailAccountsStatusOverview"
// eslint-disable-next-line import/no-cycle
import LinkedinConnectionProcess from "../components/atoms/LinkedinConnectionProcess"
// eslint-disable-next-line import/no-cycle
import { ModalVariant } from "../components/atoms/Modal"
// eslint-disable-next-line import/no-cycle
import ProxyModal from "../components/atoms/ProxyModal"
import LinkedinLogin from "../components/layouts/LinkedinLogin"
import AddLinkedinAccountModal from "../components/organisms/AddLinkedinAccountModal"
import EmailIntegrations from "../components/organisms/EmailIntegrations"
import LinkedinAddAccountBody from "../components/organisms/LinkedinAddAccountBody"
import {
  ACTIVE_STATUS_IDS,
  labelStatusModal,
  LINKEDIN_ACCOUNT_GLOBAL_STATUS,
} from "../constants/account-statuses"
import ACTIONS from "../constants/ACTIONS"
import { MODAL_HEADER_VARIANT } from "../constants/modal-constants"
import settingsConstants from "../constants/settings-constants"
import * as actions from "../redux/actions"
import { setActiveAccountID, updateFormFields } from "../redux/actions"
import { store } from "../redux/store"
import dataUtils from "./data/data-utils"
import {
  getUserType,
  hasPermission,
  PERMISSIONS,
  USER_TYPES,
} from "./team-management/team-management-utils"
import {
  validateAddAccountStep2,
  validateAddLinkedinAccount,
  validateVerifyPin,
  validateVerifyTwoFactorAuth,
  validateWrongAuth,
} from "./validation/validation-utils"
import { hideBilling, isNotSkylead } from "./whitelabel-utils"

export const getFilteredStatusId = status => {
  return ACTIVE_STATUS_IDS.includes(status) ? 5 : status
}

export const isAccountActive = (accountGlobalStatusId, accountPaymentStatusId, suspended) => {
  if (suspended) {
    return false
  }

  /** canceled account but still active */
  if (accountGlobalStatusId === 8 && accountPaymentStatusId === 1) {
    return true
  }

  /** not payment needed */
  return accountPaymentStatusId !== 2 && accountGlobalStatusId !== 7
}

export const choosePerson = async (
  person,
  settingsClick = false,
  newState = {},
  small,
  userID,
  selectedTeam,
  setState,
  shouldFetchAccountData,
  navigate,
) => {
  const {
    id,
    accountGlobalStatusId,
    accountPaymentStatusId,
    fullName,
    theme,
    linkedinSubscriptionId,
  } = person

  /** The awaits in this function have been removed on purpose, due to performance issues while they were present. */
  store.dispatch(actions.clearAllCampaignNames())
  store.dispatch(actions.getAccountProxy(id))
  if (
    (small && isAccountActive(accountGlobalStatusId, accountPaymentStatusId, person.suspended)) ||
    !small
  ) {
    if (setState) {
      setState({ selectedAccount: person, ...newState })
    }
    store.dispatch(actions.updateFormField("newAccountName", fullName))

    localStorage.setItem("selectedAccountID", id)
    store.dispatch(actions.setActiveAccountID(id))
    if (selectedTeam?.canManagePayment) {
      store.dispatch(actions.getAccountSpecificPrices(id))
    }

    localStorage.setItem("selectedTheme", theme)
    if (
      isAccountActive(accountGlobalStatusId, accountPaymentStatusId, person.suspended) &&
      !settingsClick
    ) {
      navigate(`/users/${userID}/teams/${selectedTeam?.teamId}/accounts/${id}`)
    }
    if (theme === "1") {
      document.getElementById("app-content-body").classList.add("theme-1")
      document.getElementById("app-content-body").classList.remove("theme-2")
    } else {
      document.getElementById("app-content-body").classList.add("theme-2")
      document.getElementById("app-content-body").classList.remove("theme-1")
    }
    store.dispatch(actions.updateFormField("linkedin-subscription", linkedinSubscriptionId))

    if (shouldFetchAccountData) {
      await store.dispatch(actions.getAccountData())
    }
  }
}

export const handleSubmitWrongAuth = async () => {
  const { emailAddressUpdate, passwordUpdate } = store.getState().forms.formData
  const allErrors = validateWrongAuth({ emailAddressUpdate, passwordUpdate })
  store.dispatch(actions.setFormErrors(allErrors))

  if (!allErrors) {
    const isChanged = await store.dispatch(
      actions.updateLinkedinCredentials(emailAddressUpdate, passwordUpdate),
    )

    if (isChanged) {
      await store.dispatch(actions.hideInfoModal())
    }
  }
  return !allErrors
}

export const connectionProcessModal = async () => {
  await store.dispatch(actions.getGlobalStatus())
  const { globalStatus } = store.getState().account

  store.dispatch(
    actions.showModal(
      ModalVariant.SMALL,
      undefined,
      <LinkedinConnectionProcess initialGlobalStatusState={globalStatus} />,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    ),
  )
}

export const verifyPin = async () => {
  const { totpToken } = store.getState().forms.formData
  store.dispatch(actions.clearFormErrors())
  const allErrors = validateVerifyPin({ totpToken })
  store.dispatch(actions.setFormErrors(allErrors))

  if (!allErrors) {
    const isVerified = await store.dispatch(actions.verifyPin(totpToken))
    if (isVerified) {
      connectionProcessModal()
    }
  }
  return !allErrors
}

export const clearModalReduxFields = () => {
  store.dispatch(
    updateFormFields({
      headerClassRedux: undefined,
      titleRedux: undefined,
      primaryBtnRedux: undefined,
      secondaryBtnRedux: undefined,
      tertiaryBtnRedux: undefined,
      footerVariantRedux: undefined,
      noHideOnSubmitRedux: undefined,
    }),
  )
}

export const loginWithStream = async tt => {
  const onStreamDisconnect = async () => {
    connectionProcessModal()
    store.dispatch({ type: ACTIONS.FREE_STREAM })
    store.dispatch(actions.closeOverlay())
  }

  const onStreamEnd = async () => {
    store.dispatch(actions.closeModal())
    store.dispatch(actions.closeOverlay())
    store.dispatch(actions.endStream(false))
  }

  const streamContent = (
    <LinkedinLogin onStreamEnd={onStreamEnd} onDisconnect={onStreamDisconnect} centerContent />
  )

  store.dispatch(actions.closeModal())
  store.dispatch(actions.streamLinkedinLogin(tt))
  store.dispatch(
    actions.showOverlay({
      title: tt("login-with-stream.title"),
      children: streamContent,
      footerButtonFunctions: [onStreamEnd],
      footerVariant: FooterVariant.ACKNOWLEDGMENT,
      overlayWrapperStyles: { zIndex: 20000, overflow: "hidden" },
      pageType: OverlayPages.STREAM_PAGE,
    }),
  )
}

export const verifyTwoFactorAuth = async () => {
  const { totpToken } = store.getState().forms.formData
  const allErrors = validateVerifyTwoFactorAuth({ totpToken })
  store.dispatch(actions.setFormErrors(allErrors))

  if (!allErrors) {
    const isVerified = await store.dispatch(actions.verifyTwoFactorAuth(totpToken))
    if (isVerified) {
      connectionProcessModal()
    }
  }
  return !allErrors
}

const changeLinkedinSubscription = async tt => {
  await store.dispatch(
    actions.changeLinkedinSubscription(
      tt,
      store.getState().forms.formData["linkedin-subscription"],
      true,
    ),
  )
  await store.dispatch(actions.hideInfoModal())
}

const submitReactivateProxy = async (tt, event, selectedAccount) => {
  event.preventDefault()
  event.stopPropagation()

  const { selectedProxy, proxyHostWithPort, proxyUsername, proxyPassword, showDefaultProxies } =
    store.getState().forms.formData

  store.dispatch(actions.clearFormErrors())

  const allErrors = validateAddAccountStep2({
    selectedProxy,
    showDefaultProxies,
    proxyHostWithPort,
    proxyUsername,
    proxyPassword,
  })
  store.dispatch(actions.setFormErrors(allErrors))

  if (allErrors) {
    return false
  }

  await store.dispatch(
    actions.reactivateAccount(
      tt,
      selectedAccount.id,
      showDefaultProxies,
      dataUtils.filterProxy(selectedProxy),
      {
        proxyHostWithPort,
        proxyUsername,
        proxyPassword,
      },
    ),
  )
}

const renderReactivateProxyModal = (tt, selectedAccount) => {
  store.dispatch(
    actions.showModal(
      ModalVariant.SMALL,
      tt("select-account-proxy"),
      <>
        <ProxyModal />
      </>,
      FooterVariant.TRANSACTIONAL,
      { label: tt("submit"), onClick: e => submitReactivateProxy(tt, e, selectedAccount) },
      {
        label: tt("cancel"),
        onClick: () => store.dispatch(actions.closeModal()),
      },
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
    ),
  )
}

const handleReactivate = (tt, selectedAccount) => {
  if (selectedAccount.accountPaymentStatusId === 2) {
    store.dispatch(actions.updateFormField("showDefaultProxies", true))
    renderReactivateProxyModal(tt, selectedAccount)
  } else {
    store.dispatch(actions.reactivateAccount(tt, selectedAccount.id))
  }
}

export const reactivateAccountModal = (tt, selectedAccount) => {
  const { currentPlanId } = store.getState().payment.accountSpecificPrices
  const { availableSeats, pricingPlans } = store.getState().payment

  const currentPlanName = pricingPlans.find(plan => plan.id === currentPlanId)?.name
  const availableSeatsForCurrentPlan = availableSeats.find(
    seat => seat.planId === currentPlanId,
  )?.quantity

  const ACCOUNT_HAS_ACTIVE_BILLING = 1

  if (selectedAccount.accountPaymentStatusId === ACCOUNT_HAS_ACTIVE_BILLING) {
    store.dispatch(actions.reactivateAccount(tt, selectedAccount.id))
  } else if (availableSeatsForCurrentPlan > 0) {
    store.dispatch(
      actions.showPrompt(
        PromptVariant.WARNING,
        tt("reactivate-account"),
        tt("reactivate-account-msg", { action: currentPlanName }),
        () => handleReactivate(tt, selectedAccount),
        tt("submit"),
        undefined,
        undefined,
        undefined,
        FooterVariant.TRANSACTIONAL,
      ),
    )
  } else {
    const userData = store.getState().user.profile
    const { selectedTeam } = store.getState().teamManagement

    const showBuyButton = () => {
      if (!isNotSkylead()) {
        return true
      }

      if (
        !hideBilling() &&
        ([USER_TYPES.PLATFORM_CO_OWNER].includes(getUserType(userData.userTypeId)) ||
          ([USER_TYPES.SUPER_ADMIN].includes(getUserType(userData.userTypeId)) &&
            selectedTeam.isSuperAdminTeam))
      ) {
        return true
      }

      return false
    }

    store.dispatch(
      actions.showPrompt(
        PromptVariant.WARNING,
        tt("reactivate-account"),
        <>
          <p>
            {tt("reactivate-account-modal.account-message.msg.1")} {currentPlanName}{" "}
            {tt("reactivate-account-modal.account-message.msg.2")}
          </p>
          <span>{tt("reactivate-account-modal.account-message.msg.3")}</span>
        </>,
        showBuyButton()
          ? () => {
              pricingPlans.forEach(plan => {
                store.dispatch(actions.updateFormField(`${plan.name}-seats`, 1))
              })
              store.dispatch(actions.updateFormField("showBuySeatModal", true))
              store.dispatch(actions.closeModal())
            }
          : undefined,
        showBuyButton() ? tt("buy-seats") : undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        showBuyButton(),
        FooterVariant.TRANSACTIONAL,
      ),
    )
  }
}

export const getLabelModalAction = (tt, statusName, person) => {
  if (statusName === "WRONG_AUTH") {
    return handleSubmitWrongAuth
  }

  if (statusName === "PIN_REQUESTED" || statusName === "PIN_WRONG") {
    return verifyPin
  }

  if (statusName === "TWO_FACTOR_AUTH" || statusName === "TWO_FACTOR_AUTH_WRONG") {
    return verifyTwoFactorAuth
  }

  if (statusName === "INVALID_SUBSCRIPTION") {
    return () => changeLinkedinSubscription(tt)
  }

  if (statusName === "CANCELED") {
    return () => reactivateAccountModal(tt, person)
  }

  return undefined
}

// TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
// const closeIntegrationsModal = async () => {
//   store.dispatch(actions.closeModal())
//   store.dispatch(actions.updateFormField("seatName", ""))
//   await store.dispatch(actions.getTeamAccounts())
// }

// TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
// export const integrationsModal = async (seat, proxyCountries) => {
//   const { showSeatInfo } = store.getState().forms.formData
//   await store.dispatch(
//     actions.showModal(
//       ModalVariant.LARGE,
//       <div>
//         <h1>Integrations</h1>
//         {showSeatInfo ? (
//           <div className="two-step-progress">
//             <Stepper steps={[{ label: "Seat Info" }, { label: "Integrations" }]} activeStep={1} />
//           </div>
//         ) : (
//           <Stepper
//             steps={[
//               { label: "Add Seats" },
//               { label: "Payment" },
//               { label: "Seat Info" },
//               { label: "Integrations" },
//             ]}
//             activeStep={3}
//           />
//         )}
//       </div>,
//       <LinkedinAddAccountBody modal="INTEGRATIONS" person={seat} proxyCountries={proxyCountries} />,
//       FooterVariant.ACKNOWLEDGMENT,
//       {
//         label: "Cancel",
//         onClick: async () => {
//           await closeIntegrationsModal()
//         },
//       },
//       undefined,
//       undefined,
//       async () => {
//         await closeIntegrationsModal()
//       },
//       "Cancel",
//       true,
//       false,
//       true,
//       false,
//       undefined,
//       "seat-info-modal",
//     ),
//   )
// }

// TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
// eslint-disable-next-line no-unused-vars
const closeProxyModal = async (person, proxyCountries, showIntegrationModal) => {
  // if (showIntegrationModal) {
  //   await integrationsModal(person, proxyCountries)
  // } else {
  store.dispatch(actions.closeModal())
  // }
}

const validateLinkedinAccount = () => {
  const { emailAddress, password, selectedProxy, proxyHostWithPort, proxyUsername, proxyPassword } =
    store.getState().forms.formData

  store.dispatch(actions.clearFormErrors())
  const allErrors = validateAddLinkedinAccount({
    emailAddress,
    password,
    selectedProxy,
    proxyHostWithPort,
    proxyUsername,
    proxyPassword,
  })
  store.dispatch(actions.setFormErrors(allErrors))
  return !allErrors
}

export const handleAddLinkedinAccount = async (
  tt,
  person,
  proxyCountries /* , showIntegrationModal */,
) => {
  const isValidated = validateLinkedinAccount()
  store.dispatch(actions.setFormErrors(isValidated))
  store.dispatch(actions.setActiveAccountID(person.id))

  // TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
  // const { seat } = store.getState().user
  if (isValidated) {
    const {
      emailAddress,
      password,
      selectedProxy,
      proxyHostWithPort,
      proxyUsername,
      proxyPassword,
      showDefaultProxies,
    } = store.getState().forms.formData

    const connected = await store.dispatch(
      actions.connectLinkedinAccount(
        tt,
        person.id,
        showDefaultProxies,
        dataUtils.filterProxy(selectedProxy),
        {
          proxyHostWithPort,
          proxyUsername,
          proxyPassword,
        },
        emailAddress,
        password,
      ),
    )

    if (connected) {
      await store.dispatch(actions.getTeamAccounts())
      store.dispatch(actions.hideInfoModal())
      await closeProxyModal(person, proxyCountries)
      connectionProcessModal()
      const seatId = store.getState().user.seat.id
      const activeAccountId = store.getState().account.activeAccountID
      const accountId = seatId || activeAccountId
      const teamAccounts = store.getState().teamManagement.teamAccounts.items
      const currentSeat = teamAccounts.find(account => account.id === Number(accountId)) || {}
      store.dispatch(actions.updateFormField("currentSeat", currentSeat))

      // TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
      // if (showIntegrationModal) {
      //   integrationsModal(seat, proxyCountries)
      // }
    }
    return false
  }
}

export const addLinkedinAccountModal2 = async (tt, person, proxyCountries) => {
  const { selectedProxy, proxyHostWithPort, proxyUsername, proxyPassword, showDefaultProxies } =
    store.getState().forms.formData

  store.dispatch(actions.clearFormErrors())

  const allErrors = validateAddAccountStep2({
    selectedProxy,
    showDefaultProxies,
    proxyHostWithPort,
    proxyUsername,
    proxyPassword,
  })

  store.dispatch(actions.setFormErrors(allErrors))

  if (allErrors) {
    return false
  }

  await store.dispatch(
    actions.showModal(
      ModalVariant.SMALL,
      tt("connect-your-linkedin-account"),
      <LinkedinAddAccountBody modal="LINKEDIN" person={person} proxyCountries={proxyCountries} />,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      <AddLinkedinAccountModal activeStep={1} />,
    ),
  )
}

export const addLinkedinAccountModal = async (tt, person, proxyCountries, showIntegrationModal) => {
  store.dispatch(actions.updateFormField("showDefaultProxies", true))

  await store.dispatch(
    actions.showModal(
      ModalVariant.SMALL,
      tt("connect-your-linkedin-account"),
      <LinkedinAddAccountBody modal="PROXY" proxyCountries={proxyCountries} />,
      FooterVariant.PROGRESS,
      {
        label: tt("label.next"),
        onClick: () => {
          addLinkedinAccountModal2(tt, person, proxyCountries)
        },
      },
      {
        label: tt("previous"),
        disabled: true,
      },
      {
        label: tt("close"),
        onClick: () => {
          closeProxyModal(person, proxyCountries, showIntegrationModal)
        },
      },
      true,
      undefined,
      <AddLinkedinAccountModal activeStep={0} showTabItems />,
    ),
  )
}

export const showLabelModal = async (tt, person, accountStatuses, proxyCountries) => {
  await store.dispatch(actions.getGlobalStatus())
  store.dispatch(actions.clearFormErrors())

  const notConnectedStatusLinkedin = -1
  const status = person.email ? person.accountGlobalStatusId : notConnectedStatusLinkedin
  const filteredStatusId = getFilteredStatusId(status)
  const { userMessage } =
    accountStatuses.find(({ statusId }) => statusId === filteredStatusId) || {}

  store.dispatch(
    updateFormFields({
      person,
      confirmAccessToEmail: false,
      userMessage,
      accountStatuses,
    }),
  )

  if (person.suspended) {
    return store.dispatch(
      actions.showModal(
        ModalVariant.SMALL,
        tt("seat-suspended"),
        <div className="linkedin-connection-process-wrapper">
          <div className="linkedin-connection-process">
            <div className="linkedin-connection-process__image-wrapper">
              <SvgIcon
                className="linkedin-connection-process__image"
                icon="circle-half-diagonal-80"
              />
            </div>
            <div className="linkedin-connection-process__sub-text">
              <span className="small linkedin-connection-process__sub-text-status-text">
                {tt("account-utils.seat-suspended.text")}
              </span>
            </div>
          </div>
        </div>,
        FooterVariant.ACKNOWLEDGMENT,
        { label: tt("close") },
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        MODAL_HEADER_VARIANT.RED,
      ),
    )
  }

  if (status === notConnectedStatusLinkedin) {
    addLinkedinAccountModal(tt, person, proxyCountries)
  } else if (
    /**  Show old modals */
    status === LINKEDIN_ACCOUNT_GLOBAL_STATUS.UNKNOWN ||
    status === LINKEDIN_ACCOUNT_GLOBAL_STATUS.RESTRICTED ||
    status === LINKEDIN_ACCOUNT_GLOBAL_STATUS.INVALID_SUBSCRIPTION ||
    status === LINKEDIN_ACCOUNT_GLOBAL_STATUS.WRONG_AUTH ||
    status === LINKEDIN_ACCOUNT_GLOBAL_STATUS.CANCELED ||
    status === LINKEDIN_ACCOUNT_GLOBAL_STATUS.OFFLINE
  ) {
    labelStatusModal({
      tt,
      person,
      statusName: Object.keys(LINKEDIN_ACCOUNT_GLOBAL_STATUS).find(
        key => LINKEDIN_ACCOUNT_GLOBAL_STATUS[key] === status,
      ),
      userMessage,
      accountStatuses,
    })
  } else {
    connectionProcessModal()
  }
}

export const onLabelClick = async (
  tt,
  event,
  person,
  accountStatuses,
  small,
  userID,
  setState,
  proxyCountries,
  isShownInfoModal,
  noSelectSeat = false,
  navigate,
) => {
  if (event) event.stopPropagation()
  const { hasBilling } = store.getState().user.profile
  const isPaymentNeededStatus = person.accountGlobalStatusId === 7

  if (person.accountGlobalStatusId === 8) {
    store.dispatch(actions.getAccountSpecificPrices(person.id))
  }

  if (isPaymentNeededStatus && !hasBilling) {
    return
  }
  if (isPaymentNeededStatus) {
    const amountForPaymentNeeded = await store.dispatch(
      actions.getLastInvoiceAmount(person.subscriptionId),
    )

    const { customerId } = await store.dispatch(actions.getPaymentCustomer())
    if (customerId) {
      await store.dispatch(actions.getLastUsedCard())
    }

    const newState = {
      showSavedCard: store.getState().payment.savedCard.hasCard,
      amountForPaymentNeeded: amountForPaymentNeeded.amount,
      showPaymentNeededModal: true,
      noSubscription: false,
    }

    if (!noSelectSeat) {
      await choosePerson(
        person,
        true,
        newState,
        small,
        userID,
        undefined,
        setState,
        undefined,
        navigate,
      )
    }

    labelStatusModal({ tt, person, statusName: "PAYMENT_REQUIRED", undefined, accountStatuses })
  } else {
    const newState = {}
    if (!noSelectSeat) {
      await choosePerson(
        person,
        true,
        newState,
        small,
        userID,
        undefined,
        setState,
        undefined,
        navigate,
      )
    }

    showLabelModal(tt, person, accountStatuses, proxyCountries, isShownInfoModal)
  }
}
// TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
// eslint-disable-next-line no-unused-vars
const closeEmailProviderModal = async (person, proxyCountries, showIntegrationModal) => {
  // if (showIntegrationModal) {
  //   await integrationsModal(person, proxyCountries)
  // } else {
  await store.dispatch(actions.closeModal())
  // }
}

export const openEmailProviderConnect = async (
  tt,
  event,
  userID,
  person,
  proxyCountries,
  showIntegrationModal,
  teamID,
  addEmailFromSettings = false,
) => {
  const { SETTINGS_PAGE_TABS } = settingsConstants(tt)
  if (event) {
    event.stopPropagation()
  }

  const headerTitle =
    (!person.emailOauths || person.emailOauths.length === 0 || addEmailFromSettings) &&
    hasPermission(PERMISSIONS.EMAIL_SETTINGS_EDIT)
      ? tt("add-an-email-account")
      : tt("email-accounts-status-overview")

  store.dispatch(setActiveAccountID(person.id))

  store.dispatch(
    actions.showModal(
      ModalVariant.LARGE,
      headerTitle,
      (!person.emailOauths || person.emailOauths.length === 0 || addEmailFromSettings) &&
        hasPermission(PERMISSIONS.EMAIL_SETTINGS_EDIT) ? (
        <EmailIntegrations
          accountID={person.id}
          person={person}
          userID={userID}
          proxyCountries={proxyCountries}
          showIntegrationModal={showIntegrationModal}
          teamID={teamID}
        />
      ) : (
        <div>
          <EmailAccountsStatusOverview emailAccounts={person.emailOauths} />
          <Link
            to={`/users/${userID}/teams/${teamID}/accounts/${person.id}/settings?activeTab=${SETTINGS_PAGE_TABS.EMAIL_SETTINGS.urlKey}`}
          >
            <span
              className="link-to-email-settings"
              onClick={async clickEvent => {
                // If seat is canceled, show the same modal as LinkedIn (Canceled modal)
                if (person?.accountGlobalStatusId === 8) {
                  clickEvent.preventDefault()
                  await closeEmailProviderModal(person, proxyCountries, showIntegrationModal)
                  // Import necessary modules at the top if not already imported
                  const accountStatuses = store.getState().teamManagement?.accountStatuses || []
                  return onLabelClick(
                    tt,
                    clickEvent,
                    person,
                    accountStatuses,
                    false, // small
                    userID,
                    undefined, // setState
                    proxyCountries,
                    false, // isShownInfoModal
                    true, // noSelectSeat
                    undefined, // navigate
                  )
                }
                await closeEmailProviderModal(person, proxyCountries, showIntegrationModal)
              }}
            >
              {tt("open-email-provider-connect.msg")}
            </span>
          </Link>
        </div>
      ),
      FooterVariant.ACKNOWLEDGMENT,
      {
        label: tt("cancel"),
        onClick: async () => {
          await closeEmailProviderModal(person, proxyCountries, showIntegrationModal)
        },
      },
    ),
  )
}

// TODO MJ@Any: Check if we will use this modal in horizon its not in horizon for now. Don't delete this if we we didn't check this.
// eslint-disable-next-line no-unused-vars
export const disconnectLinkedinAccount = async (tt, proxyCountries, showIntegrationsModal) => {
  const { currentSeat } = store.getState().forms.formData
  const activeAccountId = store.getState().account.activeAccountID
  const accountId = currentSeat ? currentSeat.id : activeAccountId

  await store.dispatch(actions.disconnectLinkedinAccount(tt, accountId))
  await store.dispatch(actions.getTeamAccounts())

  const teamAccounts = store.getState().teamManagement.teamAccounts.items
  const seat = teamAccounts.find(account => account.id === Number(accountId)) || {}
  store.dispatch(actions.updateFormField("currentSeat", seat))

  // if (showIntegrationsModal) {
  //   integrationsModal(seat, proxyCountries)
  // }
}

export const showSeatInfoModal = async (tt, proxyCountries) => {
  await store.dispatch(
    actions.showModal(
      ModalVariant.SMALL,
      tt("add-seat"),
      <LinkedinAddAccountBody modal="SEAT_INFO" proxyCountries={proxyCountries} />,
    ),
  )
}

export default {
  onLabelClick,
  showLabelModal,
  choosePerson,
  openEmailProviderConnect,
  // integrationsModal,
  disconnectLinkedinAccount,
  addLinkedinAccountModal2,
  verifyPin,
  handleAddLinkedinAccount,
  verifyTwoFactorAuth,
  handleSubmitWrongAuth,
  getLabelModalAction,
  renderReactivateProxyModal,
}
